"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionInsightProcessModalCtrl = void 0;
const tslib_1 = require("tslib");
const services_1 = require("../../services");
class CollectionInsightProcessModalCtrl {
    constructor(collections) {
        this.collections = collections;
    }
    //we take the departmentId as a parameter to make inter department duplication easier to implement even if it is not currently needed
    insightProcessCollections() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            const departmentId = (_a = services_1.Services.Department.current) === null || _a === void 0 ? void 0 : _a.objectId;
            const collectionIds = this.collections.map(c => c.collectionId);
            if (!departmentId) {
                throw Error('No departmentId found');
            }
            return yield services_1.Services.Department.rest.Collection.insightProcess({
                departmentId,
                where: { collectionId: { $in: collectionIds } },
                dryRun: false
            });
        });
    }
}
exports.CollectionInsightProcessModalCtrl = CollectionInsightProcessModalCtrl;
//# sourceMappingURL=collection.insight.process.modal.ctrl.js.map